import { cryptoCurrencies, fiatCurrencies } from './currency';

export function isCryptoCurrency(currency: string) {
  return cryptoCurrencies.has(currency);
}

export function isFiatCurrency(currency: string) {
  return fiatCurrencies.has(currency);
}
